<template>
    <div class="fixed inset-0 z-[99999]">
        <!-- Backdrop overlay -->
        <div class="fixed inset-0 bg-gray-900 bg-opacity-10 backdrop-blur-sm"></div>
        
        <!-- Toast container -->
        <div class="fixed bottom-0 w-full overflow-hidden flex flex-col items-center justify-center shadow-lg mx-auto animate__animated animate__slideInUp" style="--animate-duration: 0.2s;">
            <div id="toast-simple" class="flex items-center w-full max-w-xs mb-12 p-4 space-x-4 text-gray-500 bg-white divide-x divide-gray-200 rounded-lg shadow-xl" role="alert">
                <font-awesome-icon icon="fa-solid fa-check" />
                <div class="pl-4 text-sm font-normal">{{ message }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            message: {
                type: String,
                required: true
            }
        }
    }
</script>
